var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"budgetModule"}},[_c('budget-component',{ref:"budgetComponent",attrs:{"id":_vm.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }